// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-view {
  background-image: url('shape_organic_1.png'), url('shape_organic_2.png');
  background-position: left top 14%,right bottom 12%;
  background-repeat: no-repeat, no-repeat;
  background-size: 15%,9%;
}

ul {
    list-style: none;
    padding: 0;
  }
  
  ul li:before {
    content: '•';
    margin-right: 10px;
  }
  ul li.active:before {
    content: '✓';
  }
  .mat-form-field{
    width: 100%;
  }

  .linner{
    position: fixed;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    
}
.flex-col {
    display: flex;
    flex-direction: row-reverse;
}
.linner .col{
    border-right: 1px solid #fff1ec;
    padding: 0;
}
.linner .col:first-child{
    margin-left: 15px;
    border-left: 1px solid #fff1ec;
}
.linner .col:last-child{
    margin-right: 15px;
}

.site-content{
    z-index: 1;
    height: 100%;
}
.linner div{
    height: 100%;
    z-index: 0;
}

form small.error{
  position: relative;
  top: -24px;
}

@media (max-width: 575px) {  
    .linner .col:nth-child(2),
    .linner .col:nth-child(3){
        display: none;
    }
    .linner .container{
        padding: 0;
    }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/reset-password/reset-password.component.css"],"names":[],"mappings":"AAAA;EACE,wEAAgH;EAChH,kDAAkD;EAClD,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;;AAEZ;AACA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,+BAA+B;IAC/B,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;IACI;;QAEI,aAAa;IACjB;IACA;QACI,UAAU;IACd;AACJ;AACA,giFAAgiF","sourcesContent":[".success-view {\n  background-image: url('../../assets/images/shape_organic_1.png'), url('../../assets/images/shape_organic_2.png');\n  background-position: left top 14%,right bottom 12%;\n  background-repeat: no-repeat, no-repeat;\n  background-size: 15%,9%;\n}\n\nul {\n    list-style: none;\n    padding: 0;\n  }\n  \n  ul li:before {\n    content: '•';\n    margin-right: 10px;\n  }\n  ul li.active:before {\n    content: '✓';\n  }\n  .mat-form-field{\n    width: 100%;\n  }\n\n  .linner{\n    position: fixed;\n    z-index: -1;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    \n}\n.flex-col {\n    display: flex;\n    flex-direction: row-reverse;\n}\n.linner .col{\n    border-right: 1px solid #fff1ec;\n    padding: 0;\n}\n.linner .col:first-child{\n    margin-left: 15px;\n    border-left: 1px solid #fff1ec;\n}\n.linner .col:last-child{\n    margin-right: 15px;\n}\n\n.site-content{\n    z-index: 1;\n    height: 100%;\n}\n.linner div{\n    height: 100%;\n    z-index: 0;\n}\n\nform small.error{\n  position: relative;\n  top: -24px;\n}\n\n@media (max-width: 575px) {  \n    .linner .col:nth-child(2),\n    .linner .col:nth-child(3){\n        display: none;\n    }\n    .linner .container{\n        padding: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
